export default "__VITE_ASSET__2736968b__"